import { BannerMobileFormData, BannerMobileOrderItem, BannerMobileGetApiResponse, BannerMobileListApiResponse } from "../context/BannerMobileContext/constants";
import { isFileObject } from "../utils/validation";
import { axiosInstance } from "../utils/axiosInstance";

const ENDPOINTS = {
	ADD: "/cms/add-mobile-banner",
	UPDATE: "/cms/update-mobile-banner",
	REMOVE: "/cms/remove-mobile-banner",
	GET: "/cms/get-mobile-banner-details",
	LIST: "/cms/get-mobile-banner-list",
	ORDER: "/cms/update-mobile-banner-orders"
};

export class BannerMobileService {
	static async addBannerMobile(bannerData: BannerMobileFormData) {
		const formData = new FormData();

		formData.append("isActive", bannerData.isActive ? "true" : "false");

		if (bannerData.image && isFileObject(bannerData.image)) {
			formData.append("image", bannerData.image);
		}

		if (bannerData.bannerMobileLocalizable && bannerData.bannerMobileLocalizable.length > 0) {
			bannerData.bannerMobileLocalizable.forEach((item, index) => {
				formData.append(`bannerMobileLocalizable[${index}].url`, item.url || "");
				formData.append(`bannerMobileLocalizable[${index}].firstHeader`, item.firstHeader || "");
				formData.append(`bannerMobileLocalizable[${index}].header`, item.header || "");
				formData.append(`bannerMobileLocalizable[${index}].body`, item.body || "");
				formData.append(`bannerMobileLocalizable[${index}].culture`, item.culture || "");
			});
		}

		return await axiosInstance.post(`${ENDPOINTS.ADD}`, formData);
	}

	static async getBannerMobileList(): Promise<BannerMobileListApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.LIST}`);
		return response.data;
	}

	static async getBannerMobileDetails(id: string): Promise<BannerMobileGetApiResponse> {
		const response = await axiosInstance.get(`${ENDPOINTS.GET}?bannerId=${id}`);
		return response.data;
	}

	static async updateBannerMobile(bannerData: BannerMobileFormData) {
		const formData = new FormData();

		formData.append("bannerId", bannerData.bannerId ?? "");
		formData.append("isActive", bannerData.isActive ? "true" : "false");

		if (bannerData.image && isFileObject(bannerData.image)) {
			formData.append("image", bannerData.image);
		}

		if (bannerData.bannerMobileLocalizable && bannerData.bannerMobileLocalizable.length > 0) {
			bannerData.bannerMobileLocalizable.forEach((item, index) => {
				formData.append(`bannerMobileLocalizable[${index}].url`, item.url || "");
				formData.append(`bannerMobileLocalizable[${index}].firstHeader`, item.firstHeader || "");
				formData.append(`bannerMobileLocalizable[${index}].header`, item.header || "");
				formData.append(`bannerMobileLocalizable[${index}].body`, item.body || "");
				formData.append(`bannerMobileLocalizable[${index}].culture`, item.culture || "");
			});
		}

		return await axiosInstance.put(`${ENDPOINTS.UPDATE}`, formData);
	}

	static async removeBannerMobile(id: string) {
		return await axiosInstance.delete(`${ENDPOINTS.REMOVE}?bannerId=${id}`);
	}

	static async updateBannerMobileOrders(orders: BannerMobileOrderItem[]) {
		const bannerList = orders
			.map((item, index) => ({
				bannerId: item.bannerId,
				displayOrder: index + 1,
			}))
			.filter((item, index) => item.displayOrder !== orders[index].displayOrder);

		if (bannerList.length === 0) {
			return { data: { result: { isSuccessful: true } } };
		}

		const formData = new FormData();

		bannerList.forEach((item, index) => {
			formData.append(`bannerMobileList[${index}].bannerId`, item.bannerId || "");
			formData.append(`bannerMobileList[${index}].displayOrder`, item.displayOrder.toString() || "");
		});

		return await axiosInstance.put(`${ENDPOINTS.ORDER}`, formData);
	}
}